export default "__VITE_ASSET__71a45dfd__"